import React from "react";
import clsx from "clsx";
import styles from "./index.module.scss";
interface Props {
	size?: "sm" | "md" | "lg";
	className?: string;
}

export default function Spinner({ size, className }: Props) {
	const cnSize = () => {
		switch (size) {
			case "sm":
				return clsx("w-4 h-4");
			case "md":
				return clsx("w-6 h-6");
			case "lg":
				return clsx("w-8 h-8");
			default:
				return clsx("w-6 h-6");
		}
	};
	return (
		<svg className={clsx(styles.spinner, cnSize(), className)} viewBox="0 0 50 50">
			<circle className={styles.path} cx="25" cy="25" r="20" fill="none" strokeWidth="4"></circle>
		</svg>
	);
}
